// 将数字转换为八进制的工具函数
export function toOctal(num) {
    return num.toString(8)
}

// 将JSON数据转换为Uint8Array
export function jsonToUint8Array(jsonData) {
    const jsonString = JSON.stringify(jsonData)
    return new TextEncoder().encode(jsonString)
}

// 创建数据头部
function createDataHeader() {
    // 只需要一个字节的reportId
    const headerBuffer = new Uint8Array(1)
    headerBuffer[0] = 0x04  // reportId
    return headerBuffer
}

// 将数据分包
// mode: 'wired' (1023字节/包) 或 '250byte' (249字节/包，无线模式)
function splitIntoPackets(data, mode = 'wired') {
    const packets = []
    let offset = 0
    const maxSize = mode === '250byte' ? 249 : 1023

    // 分包处理
    while (offset < data.length) {
        const size = Math.min(maxSize, data.length - offset)

        // 创建数据包
        const packet = new Uint8Array(size)

        // 复制数据部分
        packet.set(data.slice(offset, offset + size))

        packets.push(packet)
        offset += size
    }

    return packets
}

// 主转换函数：JSON到分包的八进制数据
// mode: 'wired' (有线模式，1023字节/包) 或 '250byte' (无线模式，249字节/包)
export function convertJsonToPackets(jsonData, mode = 'wired') {
    try {
        // 1. 将JSON转换为Uint8Array
        const rawData = jsonToUint8Array(jsonData)

        // 2. 分包
        const packets = splitIntoPackets(rawData, mode)

        // 3. 返回处理结果
        return {
            success: true,
            packets,
            totalPackets: packets.length,
            originalSize: rawData.length,
            mode: mode,
            error: null
        }
    } catch (error) {
        return {
            success: false,
            packets: [],
            totalPackets: 0,
            originalSize: 0,
            mode: mode,
            error: error.message
        }
    }
}

// 辅助函数：将Uint8Array转换为可读的十六进制字符串（用于调试）
export function arrayToHexString(array) {
    return Array.from(array)
        .map(b => b.toString(16).padStart(2, '0'))
        .join(' ')
}
